<template>
    <div>
        <div class="d-flex align-center">
            <div class="title flex-grow-1">{{$translate('Previous matches')}}</div>
            <template v-if="matches.length">
                <v-progress-circular v-if="loading" size="20" indeterminate color="primary" width="2"></v-progress-circular>
                <span v-else-if="!numMatches" style="opacity: 0.5">{{$translate('Showing all')}}</span>
                <a href @click.prevent="getAllPreviousMatches" v-else>{{$translate('Show all')}}</a>
            </template>
        </div>

        <div v-if="loading && !matches.length" class="d-flex align-center justify-center">
            <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
        </div>
        <template v-else-if="!matches.length">
            <v-card>
                <v-card-text>
                    {{$translate('No previous matches')}}
                </v-card-text>
            </v-card>
        </template>
        <template v-else>
            <div>
                <teamsport-match-result v-for="match in matches" :key="match.id" :match="match" :teamId="teamId" :showTeamNames="false" :showHomeAway="false" class="mb-4 z-clickable" @click.native="goToMatch(match)" style="cursor: pointer;" />
            </div>
            <v-btn v-if="numMatches != null" @click="getMoreMatches" block outlined color="primary" :loading="loading">{{$translate('Load more matches')}}</v-btn>
            <v-btn v-else-if="expanded" @click="showFewer" block outlined color="primary">{{$translate('Show fewer')}}</v-btn>
        </template>
    </div>
</template>

<script>
import TeamsportMatchResult from './TeamsportMatchResult.vue';
export default {
    name: 'zoezi-teamsport-previous-match',

    zoezi: {
        title: 'Previous matches',
        icon: 'mdi-calendar-clock',
        addon: 'TeamSports'
    },

    props: {
        teamId: {
            title: 'Registration ID',
            type: Number
        }
    },

    components: {
        TeamsportMatchResult
    },

    data: () => ({
        matches: [],
        defaultNumMatches: 3,
        numMatches: 3,
        loading: false,
        expanded: false,
        unsubscribe: []
    }),

    watch: {
        teamId: {
            immediate: true,
            handler() {
                this.getPreviousMatches();
            }
        },
        '$store.state.user'() {
            this.getPreviousMatches();
        }
    },

    methods: {
        goToMatch(match) {
            const matchPage = this.$root.siteconfig?.pages?.match;
            this.$root.followLink(matchPage, match.id);
        },
        getPreviousMatches() {
            this.loading = true;
            let params = {team_id: this.teamId, limit: this.numMatches};
            this.$api.get('/api/memberapi/teamsport/match/previous', params).then(result => {
                this.matches = result.matches;
                if (result.matches.length >= result.count) {
                    this.numMatches = null;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        getAllPreviousMatches() {
            this.numMatches = null;
            this.expanded = true;
            this.getPreviousMatches();
        },
        getMoreMatches() {
            this.numMatches += this.defaultNumMatches;
            this.expanded = true;
            this.getPreviousMatches();
        },
        showFewer() {
            this.numMatches = this.defaultNumMatches;
            this.expanded = false;
            this.getPreviousMatches();
        }
    },
    mounted() {
        this.unsubscribe.push(this.$api.subscribe({type: 'teamsportmatch', callback: (_, event) => {
            const eventData = Array.isArray(event.data) ? event.data : [];
            const currentMatchIds = this.matches.map(match => match.id);
            if (eventData.find(x =>
                (x.teams && x.teams.find(team => team.id == this.teamId)) ||
                currentMatchIds.includes(x.id)
            )) {
                this.getPreviousMatches();
            }
        }}))
    },
    destroyed() {
        this.unsubscribe.forEach(x => x());
    }
}
</script>
